@let loaded = organizationSelectors.loaded | select:false;

<!-- This global nav bar is only visible on large screen sizes. -->
<div class="h-full w-full flex max-w-[84.5rem] px-8" mxHiddenUntilLoaded [reveal]="loaded">
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -- Allow dynamic gap calculation. -->
  <div #linkContainer class="h-full w-full flex flex-row items-center justify-center" [style.gap.rem]="gapInRem">
    <!-- Library Home and Catalog are fixed; the organization can configure up to four external links. -->
    <ng-container *ngTemplateOutlet="link; context: {label: 'Library Home', href: organizationSelectors.websiteUrl | select}"/>
    <ng-container *ngTemplateOutlet="link; context: {label: 'Catalog', routeName: 'CATALOG'}"/>
    @for (navLink of organizationSelectors.globalNavLinks | select; track $index) {
      <ng-container *ngTemplateOutlet="link; context: {label: navLink.label, href: navLink.href}"/>
    }
  </div>
</div>

<ng-template #link let-label="label" let-href="href" let-routeName="routeName">
  <!-- eslint-disable @nx/workspace-mx-use-button-components -- The special coloring on these links isn't supported by LinkButtonComponent. -->
  <p class="[&>*]:text-on-primary">
    @if (href) {
      <a [href]="href" [title]="label">{{ label }}</a>
    } @else if (routeName) {
      <a [pxNamedRouterLink]="routeName" [title]="label">{{ label }}</a>
    } @else {
      <span>{{ label }}</span>
    }
  </p>
  <!-- eslint-enable @nx/workspace-mx-use-button-components -->
</ng-template>
